export default "__VITE_ASSET__I3YI3aU6__"